module.exports = __webpack_public_path__ + "static/media/ACRM_lotusonly_s_4c_1597352888380.bb05ff49.png";